import {SERVICES} from '@/const';

const PREFIX_RECEIVE_V2 = `${SERVICES.IMG_URL}/v1/`;

export const IMAGES_V2 = {
  BANNER: '20b2e5d1/banner-2x.png',
  ADVANTAGE_1: '2bfa5d9a/ad-01-2x.png',
  ADVANTAGE_2: '559d05de/ad-02-2x.png',
  ADVANTAGE_3: 'c1ee9eb0/ad-03-2x.png',
  ADVANTAGE_4: '77fc0828/ad-04-2x.png',
  SOLUTION_1: '3501fd60/icon01-2x.png',
  SOLUTION_2: 'a55a8819/icon02-2x.png',
  SOLUTION_3: '61f4d04f/icon03-2x.png',
  SOLUTION_4: '78d59686/icon04-2x.png',
  SOLUTION_5: '12fb7f3d/icon05-2x.png',
  SOLUTION_6: '018ee28c/icon06-2x.png',
  PROGRAM_1: 'e8ab437a/market01-2x.png',
  PROGRAM_2: '8c2ebd4a/broker01-2x.png',
  SHARE: 'b913cccf/vector.png',
  WAIT: 'e40fe627/note.png',
  BONUS_PROGRAM_1: '5223f972-d95f-4ee4-b3ec-c97503b33298/mask-group.svg',
  BONUS_PROGRAM_2: 'ee0a863a-1e22-4093-92ab-cf04ed7e3bf5/collaborator-program-2x.png',
};

Object.keys(IMAGES_V2).forEach((key) => (IMAGES_V2[key] = [PREFIX_RECEIVE_V2, IMAGES_V2[key]].join('')));
